<template>
  <Table
    :items="orderItems"
    :selected="selected"
    :hiddenHeader="hiddenHeader"
    :sort="sort"
    v-on="$listeners"
  >
    <template #header>
      <TableHeader v-if="!hiddenOrder">配送状況</TableHeader>
      <TableHeader v-if="!hiddenOrder">受注番号</TableHeader>
      <TableHeader>{{ $t("flower_specie") }}</TableHeader>
      <TableHeader>農園名</TableHeader>
      <TableHeader>{{ $t("delivery_date") }}</TableHeader>
      <TableHeader align="right">{{ $t("unit_price") }}</TableHeader>
      <TableHeader align="right">ロット本数</TableHeader>
      <TableHeader align="right">{{ $t("set_count") }}</TableHeader>
      <TableHeader align="right">小計</TableHeader>
    </template>
    <template #body="{ item }">
      <TableCell v-if="!hiddenOrder">
        <div class="status" :class="[item.status, item.order_item_type]">{{ statusName(item) }}</div>
      </TableCell>
      <TableCell v-if="!hiddenOrder">{{ item.id }}</TableCell>
      <TableCell>
        <div class="d-flex align-center">
          <div>
            <div class="genus">{{ item.flower.flower_specie.flower_genus.name }}</div>
            <div class="specie">{{ item.flower.flower_specie.name }}</div>
          </div>
        </div>
      </TableCell>
      <TableCell>{{ item.farm.name }}</TableCell>
      <TableCell>
        <span class="date">{{ $d(item.delivery_date, "date") }}</span>
      </TableCell>
      <TableCell align="right">
        <span class="unit">¥</span>
        <span class="number">{{ $n(item.sales_price) }}</span>
      </TableCell>
      <TableCell align="right">
        <span class="number">{{ item.flower_harvest.min_count }}</span>
        <span class="unit">本</span>
      </TableCell>
      <TableCell align="right">
        <span
          class="number"
          :style="item.status === 'rollback' && 'color: red;'"
        >{{ item.count / item.flower_harvest.min_count }}</span>
        <span class="unit" :style="item.status === 'rollback' && 'color: red;'">口</span>
      </TableCell>
      <TableCell align="right" :class="item.status">
        <span class="total-unit" :style="item.status === 'rollback' && 'color: red;'">¥</span>
        <span
          class="number"
          :style="item.status === 'rollback' && 'color: red;'"
        >{{ $n(item.subtotal_sales_price_without_tax) }}</span>
        <span
          class="number delivery-fee"
          :style="item.status === 'rollback' && 'color: red;'"
        >（内送料¥{{ $n(item.subtotal_delivery_fee) }}）</span>
      </TableCell>
    </template>
  </Table>
</template>

<script>
import Table from "@/components/shop/Table.vue";
import TableHeader from "@/components/shop/TableHeader.vue";
import TableCell from "@/components/shop/TableCell.vue";

export default {
  components: {
    Table,
    TableHeader,
    TableCell,
  },

  props: {
    items: {
      type: Array,
      required: true,
    },
    selected: {
      type: Array,
      default: null,
    },
    hiddenOrder: {
      type: Boolean,
      default: false,
    },
    hiddenHeader: {
      type: Boolean,
      default: false,
    },
    sort: {
      type: Object,
      default: () => ({}),
    },
  },

  methods: {
    statusName(order_item) {
      if (["unloaded", "picked"].includes(order_item.status)) {
        return this.$t("shipped");
      } if (order_item.order_item_type === "request" && order_item.status === "unconfirmed") {
        return this.$t("request_unconfirmed");
      } if (order_item.order_item_type === "request" && order_item.status === "canceled") {
        return this.$t("request_rejected");
      }
      return this.$t(order_item.status);
    }
  },
  computed: {
    orderItems() {
      return this.items.filter(item => item.status !== "rollback");
    }
  }
};
</script>

<style lang="scss" scoped>
.status {
  font-size: 10px;
  color: #ff9076;
  padding: 0 8px;
  line-height: 16px;
  border: currentColor 1px solid;
  border-radius: 2px;

  &.delivered {
    background-color: #FF8C71;
    color: #fff;
  }

  &.shipped {
    background-color: #007e57;
    color: #fff;
  }

  &.rollback {
    color: red;
  }

  &.canceled {
    &.request {
      background-color: #777;
      color: #fff;
    }
  }
}
.rollback {
  color: red !important;
}

.genus {
  font-size: 10px;
  color: #555;
}

.specie {
  color: #333;
  font-size: 16px;
  font-weight: bold;
}

.number {
  color: #333;
  font-size: 19px;
  font-weight: bold;
}

.unit {
  margin-left: 2px;
  color: #777;
  font-size: 12px;
}

.favorite {
  color: #bdbdbd;

  &.active {
    color: #ff8c71;
  }
}

.total-unit {
  margin-right: 2px;
}

.delivery-fee {
  font-size: 14px;
  line-height: 17px;
}
</style>
